require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/modules/es7.symbol.observable.js
// module id = 67
// module chunks = 0